module.exports = __webpack_public_path__ + "img/mfms.56b54d97.png";